
    import debounce from 'lodash/debounce';
    import { mapState, mapActions } from 'vuex';
    import { ValidationProvider } from 'vee-validate';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faEdit as falEdit,
    } from '@fortawesome/pro-light-svg-icons/faEdit';

    import VueSelect from '@/components/VueSelect/VueSelect';
    import VueSelectDivider from '@/components/VueSelect/VueSelectDivider';
    import C1FormInput from '@/C1Components/C1FormInput';
    import C1FormTextarea from '@/C1Components/C1FormTextarea';
    import C1Label from '@/C1Components/C1Label';

    export default {
        name: 'ApplyCoverLetter',

        components: {
            FontAwesomeIcon,
            C1Label,
            ValidationProvider,
            VueSelect,
            VueSelectDivider,
            C1FormInput,
            C1FormTextarea,
        },

        data() {
            return {
                selectedCoverLetter: {},
                editing: false,
                creating: false,
                applyNoCover: false,
                coverLetters: [],
                applyWithoutCoverLetterText: 'Apply without cover letter',
                writeNewCoverLetterText: 'Write a new cover letter',
                icons: {
                    falEdit,
                },
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
            }),

            defaultText() {
                if (this.editing) {
                    return this.selectedCoverLetter.title;
                }

                if (this.creating) {
                    return this.writeNewCoverLetterText;
                }

                if (this.applyNoCover) {
                    return this.applyWithoutCoverLetterText;
                }

                return this.applyWithoutCoverLetterText;
            },
        },

        created() {
            if (this.$_me.id) {
                this.getCoverLetters();
            }
        },

        methods: {
            ...mapActions('me', {
                $_storeCoverLetter: 'storeCoverLetter',
                $_getCoverLetter: 'getCoverLetter',
                $_updateCoverLetter: 'updateCoverLetter',
            }),

            getCoverLetters() {
                this.$_getCoverLetter().then((response) => {
                    this.coverLetters = response.data;
                });
            },

            selectCoverLetter(coverLetter) {
                console.log('selectCoverLetter', coverLetter);

                this.selectedCoverLetter = coverLetter;
                this.editing = true;
                this.creating = false;
                this.applyNoCover = false;
                this.$refs.coverLetterSelect.closeMenu();
            },

            writeNewCoverLetter() {
                this.editing = false;
                this.creating = true;
                this.applyNoCover = false;
                this.resetSelectedCoverLetter();
                this.$refs.coverLetterSelect.closeMenu();
            },

            applyWithoutCoverLetter() {
                this.editing = false;
                this.creating = false;
                this.applyNoCover = true;

                this.$nextTick(() => {
                    this.resetSelectedCoverLetter();
                });

                this.$refs.coverLetterSelect.closeMenu();
            },

            resetSelectedCoverLetter() {
                this.selectedCoverLetter = {};
            },

            async validateCoverLetter() {
                const validatorTitle = await this.$refs.title.validate();
                const validatorMessage = await this.$refs.message.validate();
                if (validatorTitle && validatorMessage && this.$_me.id) {
                    this.submitCoverLetter();
                }
            },

            submitCoverLetter: debounce(function() {
                if (this.selectedCoverLetter.title && this.selectedCoverLetter.body) {
                    this.selectedCoverLetter.id ? this.updateCoverLetter() : this.storeCoverLetter();
                }
            }, 1000),

            storeCoverLetter() {
                const data = {
                    title: this.selectedCoverLetter.title,
                    body: this.selectedCoverLetter.body,
                };

                this.$_storeCoverLetter(data).then((response) => {
                    this.coverLetters.push(response.data);
                    this.selectCoverLetter(response.data);
                });
            },

            updateCoverLetter() {
                const data = {
                    title: this.selectedCoverLetter.title,
                    body: this.selectedCoverLetter.body,
                };

                this.$_updateCoverLetter({
                    id: this.selectedCoverLetter.id,
                    data,
                });
            },
        },
    };
